import { yupResolver } from '@hookform/resolvers/yup'
import PropTypes from 'prop-types'
import { FormProvider, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import SidePopover from '@/components/side-popover/SidePopover.jsx'
import CostsRDForm from '@/pages/projects/detail/detail-r&d/r&d-form/costs-rd-form/CostsRDForm.jsx'
import {
    validationSchema,
    DEFAULT_COSTS_PROJECTS_MOCK,
} from '@/pages/projects/detail/detail-r&d/r&d-form/costs-rd-form/costsRDForm.schema.js'

const CostsRDFormWrapper = ({
    dataForm,
    closeModal,
    openDialogDelete,
    isEdit,
    sals,
    suppliers,
    isFinance,
}) => {
    const { t } = useTranslation()

    const methods = useForm({
        shouldUnregister: false,
        mode: 'all',
        reValidateMode: 'onChange',
        nativeValidation: false,
        shouldFocusError: true,
        resolver: yupResolver(validationSchema),
        defaultValues: DEFAULT_COSTS_PROJECTS_MOCK,
    })

    const {
        formState: { isDirty },
    } = methods

    return (
        <FormProvider {...methods}>
            <SidePopover
                onClose={() => closeModal(isDirty)}
                isDirty={isDirty}
                title={
                    isEdit
                        ? t(`costs_project.edit_title`)
                        : t(`costs_project.create_title`)
                }
            >
                <CostsRDForm
                    isEdit={isEdit}
                    closeModal={closeModal}
                    dataForm={dataForm}
                    openDialogDelete={openDialogDelete}
                    sals={sals}
                    suppliers={suppliers}
                    isFinance={isFinance}
                />
            </SidePopover>
        </FormProvider>
    )
}

export default CostsRDFormWrapper

CostsRDFormWrapper.propTypes = {
    dataForm: PropTypes.object,
    onClose: PropTypes.func,
    closeModal: PropTypes.func,
    setIsLoading: PropTypes.func,
    openDialogDelete: PropTypes.func,
    isEdit: PropTypes.bool,
    suppliers: PropTypes.array,
    sals: PropTypes.array,
    isFinance: PropTypes.bool,
}
